<!--
* @description  参数1
* @fileName  goods
* @author userName
* @date 2024-01-08 11:35:57
!-->
<template>
  <div id="goods" v-clickoutside="closePanel" class="goods">
    <input
      :ref="`${searchKeysType}Input`"
      v-model="text"
      :class="{ 'active-border': true, 'input-error': inputErrorShow, 'input-disabled': disabled }"
      :placeholder="placeholderShow"
      :style="{ width: width + 'px' }"
      :disabled="disabled"
      @focus="focusInput"
      @blur="blurInput"
    >
    <el-collapse-transition>
      <div
        v-if="panelShow"
        :class="{ 'by-panel': true,}"
        @mouseenter="panelOpen = true"
        @mouseleave="panelOpen = false"
      >
        <div class="load-title">
          <span>┃</span>
          <span>Tell us about your goods </span>
        </div>
        <div class="form-class main-info check-price-form">
          <el-form
            ref="formData"
            :model="formData"
            :rules="allRules"
            label-position="top"
            size="medium"
            class="item-Surcharge"
            @submit.native.prevent
          >
            <div class="form-item">
              <div class="flex-left">
                <div class="wenhao-tip">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="You can find your goods value on your commercial invoice."
                    popper-class="tooltip-popper-class"
                    placement="top"
                  >
                    <div>?</div>
                  </el-tooltip>
                </div>
                <el-form-item class="flex-width_1 " prop="goodsValue" label="Goods value">
                  <input v-model="formData.goodsValue" class="left">
                  <p class="right">USD</p>
                </el-form-item>
                <el-form-item class="flex-width_1" prop="goodsReadyTime" label="Are your goods ready?">
                  <el-select
                    v-model="formData.goodsReadyTime"
                    popper-class="cargo_info_select"
                    placeholder="Select timeframe"
                    @change="getReady"
                  >
                    <el-option
                      v-for="item in readyOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
                <div v-if="formData.goodsReadyTime" class="blue-tip">
                  <img src="../../../assets/img/manage/ic_warning.png" width="16px" height="16px">
                  <span>
                    {{ readyTip }}
                  </span>
                </div>
              </div>
              <div class="flex-right">
                <el-form-item
                  class="flex-width_1"
                  prop="goodsType"
                  label="Does your shipment contain any of the following goods?"
                >
                  <el-select
                    v-model="formData.goodsType"
                    popper-class="cargo_info_select"
                    placeholder=""
                    multiple
                    @change="goodsTypeChange"
                  >
                    <el-option
                      v-for="item in goodsOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    >
                      <span>{{ item.label }}</span>
                      <div class="wenhao-tip">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.description"
                          popper-class="tooltip-popper-class"
                          placement="top"
                        >
                          <div>?</div>
                        </el-tooltip>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="flex-width_1" prop="goodsName" label="Product name">
                  <el-input v-model="formData.goodsName" />
                </el-form-item>
                <div class="error-tip">
                  <img
                    src="../../../assets/img/manage/ic_warning@2x(1).png"
                    width="16px"
                    height="16px"
                  >
                  <span>
                    All prohibited items containing liquids, powders, imitation brands, pastes, etc.
                    are
                    not accepted. If the declaration is not truthful, once found, the system will
                    fasten
                    the piece and levy a compensation of up to US $2,000.Learn more.
                  </span>
                </div>
              </div>

            </div>
          </el-form>
        </div>
        <div class="foot-button">
          <button
            type="button"
            :class="[{'confirm-button-ok':isAllOk}]"
            @click.stop="ConfirmGoTo"
          >Confirm</button>
        </div>

      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import {
  getDictionaryDataSelector
} from '@/api/base.js'
export default {
  name: 'Goods',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    // 父辈向子辈传参
    disabled: {
      // 禁用输入
      type: Boolean,
      default: false
    },
    searchKeysType: {
      // 搜索关键词
      type: String,
      required: true,
      default: 'City'
    },
    width: {
      type: String,
      required: false,
      default: '200'
    },
    placeholder: {
      // 输入框默认提示
      // type: String,
      required: false,
      default: ''
    },
    destType: {
      type: Number,
      required: false,
      default: 4
    }
  },
  data() {
    return {
      text: '', // 输入框显示文字
      panelShow: false,
      inputErrorShow: false,
      panelOpen: false,
      placeholderShow: 'Tell us about your goods', // 输入框默认显示提示文字
      isHazardous: '', // 是否有危险货物
      formData: {
        goodsValue: '',
        goodsName: '',
        goodsReadyTime: '',
        goodsType: []
      },
      allRules: {
        goodsValue: [{
          required: true,
          message: 'required'
        }],
        goodsName: [{
          required: true,
          message: 'required'
        }],
        goodsReadyTime: [{
          required: true,
          message: 'required'
        }],
        goodsType: [{
          required: true,
          message: 'required'
        }]
      },
      goodsOptions: [],
      readyTip: '',
      readyOptions: [{
        label: 'Yes, my goods are ready',
        value: 1
      },
      {
        label: 'Will be ready within two weeks',
        value: 2
      },
      {
        label: 'Will be ready in more than two weeks',
        value: 3
      }
      ]
    }
  },
  computed: {
    // 计算属性
    isAllOk() {
      return this.formData.goodsValue && this.formData.goodsType && this.formData.goodsName && this.formData
        .goodsReadyTime
    }
  },
  watch: {
    // 监测变化
    'formData.ready': {
      handler(val) {
        if (val === 3) {
          this.readyTip =
							'Please note, rates on Flexshipping.com are updated every two weeks. If your goods will only be ready and gated-in after the expiry date (found on each Quote tile), your rates will be different from when selected.'
        } else {
          this.readyTip =
							'Please note the expiry date on each Quote tile. Rates are subject to change if your goods are not gated-in before that date.'
        }
      },
      deep: true,
      immediate: true
    },
    'destType': {
      handler(val) {
        this.getCaroTypes(val)
      }
    },
    panelShow(val) {
      // 获取组件的聚焦状态
      this.$emit('getFocusStatus', val)
    }
  },
  created() {
    // 实例被创建之后执行代码
    this.getCaroTypes()
  },
  mounted() {
    // 页面进入时加载内容
    // document.body.style.overflowY = 'hidden';
  },
  methods: {
    goodsTypeChange(val) {
      if (Array.isArray(val)) {
        var arr = val
        var index = arr.indexOf(1)
        if (index >= 0) {
          if (arr[arr.length - 1] == 1) {
            this.formData.goodsType = [1]
          } else {
            this.formData.goodsType = arr.filter(item => item != 1)
          }
        }
      } else {
        // this.formData.goodsType = [val]
      }
    },
    getCaroTypes(destType) {
      this.goodsOptions = []
      if (destType === 3) {
        getDictionaryDataSelector('fbagoods').then(res => {
          if (res.code === 200) {
            res.data.list.forEach(item => {
              try {
				  var lan = item.language
				  var data = {
				    value: parseInt(item.enCode),
				    label: lan.en,
				    description: item.description
				  }
				  this.goodsOptions.push(data)
              } catch (e) {
                console.log(e)
              }
            })
          }
        })
      } else {
        getDictionaryDataSelector('expCargo').then(res => {
          if (res.code === 200) {
            res.data.list.forEach(item => {
              var lan = item.language
              var data = {
                value: parseInt(item.enCode),
                label: lan.en,
                description: item.description
              }
              this.goodsOptions.push(data)
            })
          }
        })
      }
    },
    // 打开下拉列表
    focusInput() {
      this.panelShow = true
      // 获取选中
      // this.$nextTick(() => {
      //   this.$refs[`${this.searchKeysType}Input`].select();
      // });
    },
    // 输入框失去焦点
    blurInput() {
      this.placeholderShow = this.placeholder
      if (!this.panelOpen) {
        this.closePanel(1)
      }
    },
    // 关闭下拉列表
    closePanel(val) {
      this.panelShow = false
      if (val == 1) {
        this.$emit('blur')
      }
    },
    getReady(val) {
      // 货好时间
      this.formData.goodsReadyTime = val
    },
    ConfirmGoTo() {
      this.$refs.formData.validate(valid => {
        var readyTxt = ''
        if (this.formData.goodsReadyTime === 1) {
          readyTxt = 'Goods are ready'
        } else if (this.formData.goodsReadyTime === 2) {
          readyTxt = 'Within 2 weeks'
        } else {
          readyTxt = 'More than 2 weeks'
        }
        this.text = '$' + this.formData.goodsValue + ' | ' + this.formData.goodsName +
						' | ' + readyTxt + ''
        this.$emit('next', this.formData)
        this.closePanel(1)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.goods {
		input {
			outline: none;
			border: none;
			height: 32px;
			background: transparent;
			position: relative;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 550;
			color: #333333;
			line-height: 22px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		input::-webkit-input-placeholder {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #aaaaaa;
			line-height: 22px;
		}

		.input-error {
			&::-webkit-input-placeholder {
				color: #d83f3f;
			}
		}

		.input-disabled {
			color: #777;
		}

		.by-panel {
			position: absolute;
			left: 0px;
			top: 83px;
			z-index: 10;
			width: 792px;
			height: 384px;
			background: #FFFFFF;
			box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid rgba(221, 221, 221, 0.56);
			overflow: auto;

			//overflow-y: scroll;
			//height: 50vh;
			.load-title {
				height: 32px;
				text-align: left;
				margin: 8px 16px;

				span:nth-of-type(1) {
					color: #E95506;
					margin-right: 10px;
				}

				span:nth-of-type(2) {
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
				}
			}

			.form-item {
				margin-left: 16px;
				display: flex;

				.flex-left {
					width: 296px;
				}

				.flex-right {
					width: 498px;
				}

				::v-deep .el-form-item {
					margin-bottom: 0;

					.el-form-item__label {
						display: -webkit-box;
						//display: flex;
						padding: 0;
						margin-top: 4px;
					}

					.el-input__inner {
						height: 40px !important;
					}

				}

				.wenhao-tip {
					position: absolute;
					top: 60px;
					left: 105px;
					font-size: 12px;
					width: 12px;
					height: 12px;
					border: 1px solid #333333;
					color: #333333;
					border-radius: 50%;

					&:hover {
						border: 1px solid #027FFC;
						color: #027FFC;
					}
				}

				.flex-width_1 {
					margin-right: 16px;

					::v-deep .el-form-item__content {
						display: flex;

						.el-select {
							width: 100%;
						}

						.left {
							width: 259px;
							border-top-left-radius: 3px;
							border-bottom-left-radius: 3px;
							border: 1px solid #ddd;
							line-height: 40px;
							height: 40px;
							padding-left: 5px;
							box-sizing: border-box;
							float: left;
						}

						.right {
							float: left;
							width: 66px;
							font-size: 12px;
							background: #f8f8f8;
							line-height: 40px;
							height: 38px;
							text-align: center;
							border-top-right-radius: 3px;
							border-bottom-right-radius: 3px;
							border: 1px solid #dcdfe6;
							border-left: 0;
							margin: 0px;
						}
					}

				}

				.el-checkbox-style {
					margin: 10px 0px;
					display: flex;
				}

				.el-checkbox-style ::v-deep .el-checkbox {
					.el-checkbox__inner {
						width: 16px;
						height: 16px;

						&::after {
							height: 8px;
							left: 4.5px;
						}
					}

					.el-checkbox__label {
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #777777;
						line-height: 22px;
					}
				}

				.el-checkbox-style ::v-deep .is-checked {
					.el-checkbox__inner {
						border-color: #E95506;
						background: #E95506;
					}
				}

				.error-tip {
					margin: 8px 0px;
					display: flex;
					width: 456px;
					height: 68px;
					background: rgba(239, 10, 10, 0.04);
					border-radius: 4px;
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #EF0A0A;
					padding: 8px;
					text-align: left;

					img {
						margin-right: 8px;
					}
				}

				.blue-tip {
					margin: 8px 0px;
					display: flex;
					width: 264px;
					//height: 54px;
					background: rgba(2, 127, 252, 0.04);
					border-radius: 4px;
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #027FFC;
					padding: 8px;
					text-align: left;

					img {
						margin-right: 8px;
					}
				}

			}

			.foot-button {
				text-align: right;
				margin: 16px 16px 24px;

				.confirm-button-ok {
					background: #E95506 !important;
				}

				button {
					width: 108px;
					height: 40px;
					background: #F5B492;
					border-radius: 8px;
					font-size: 16px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #FFFFFF;
					line-height: 35px;
					border: 0;

					&:hover {
						background: #E95506 !important;
					}

					&:active {
						background: #E95506 !important;
					}
				}
			}
		}
	}

	.by-panel::-webkit-scrollbar {
		/* 定义滚动条样式 */
		width: 4px;
	}

	.by-panel::-webkit-scrollbar-track {
		/*定义滚动条轨道 内阴影+圆角*/
		box-shadow: inset 0 0 0px #d8d8d8;
		border-radius: 2px;
	}

	.by-panel::-webkit-scrollbar-thumb {
		/*定义滑块 内阴影+圆角*/
		border-radius: 10px;
		box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
		background-color: rgba(158, 156, 156, 0.56);
	}

  .el-select-dropdown__item{
    display: flex;
    align-items: center;
    .wenhao-tip{
      display: inline-block;
      margin-left: 5px;
      font-size: 12px;
      width: 12px;
      height: 12px;
      border: 1px solid #333333;
      color: #333333;
      border-radius: 50%;
      .el-tooltip{
        line-height: 13px;
        margin-left: 3px;
      }
    }
  }
</style>
